// CREATE - POST a new resource on backEnd
export function ulip_post(baseURL,endpoint,object){
    return fetch(baseURL+endpoint, {
        method: 'POST',
        mode: 'cors',
        cache: 'no-cache',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json'
        },
        redirect: 'follow',
        referrerPolicy: 'no-referrer',
        body: JSON.stringify(object)
    }).then(response => {
        return response.json()
    }).then( rsp => {
        //console.log('POST executed with success ..')
        return rsp
    }).catch( err => {
        //console.log('Error when POST resource: ', err.message)
        throw new Error('Create new resource! - '+err.message)
    })
}
// UPDATE - PUT a resource on backEnd
export function ulip_put(baseURL,endpoint,id,object) {
    return fetch(baseURL + endpoint+'/' + id, {
        method:'PUT',
        mode: 'cors',
        cache: 'no-cache',
        credentials: 'same-origin',
        headers: {
            'Content-Type':'application/json'
        },
        body: JSON.stringify(object)
    }).then(response => {
        return response.json()
    }).then( rsp => {
        //console.log('PUT executed with success ..')
        return rsp
    }).catch( (err) => {
        //console.log('Error when PUT resource: ', err.message)
        throw new Error('Update resource ! - '+err.message)
    })
}
/* request sending to client an email from email server
    e.g mail object
        let mail_data = {
               email: email,
               hid: this.$store.getters.getCurrentClientHID,
               name:this.$store.getters.getCurrentName,
               cid:id,
               flag:1, // send Link
   }
*/
export function ulip_request_email(baseURL,mail_object){
    return fetch(baseURL + '/mail',{
        method: 'POST',
        mode: 'cors',
        cache: 'no-cache',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json'
        },
        redirect: 'follow',
        referrerPolicy: 'no-referrer',
        body: JSON.stringify(mail_object),
    }).then(response => {
        return response.json()
    }).then(rsp => {
        return rsp
    }).catch(err => {
        return err
    })
}